module.exports = __webpack_public_path__ + "static/media/fahrradweg.8f8ca22c.svg";